import { getCookie } from 'src/misc/cookies';

export const isUserLoggedIn = () => !!getCookie('user_name');
